import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';
import {WorklistUIActionType} from 'worklists/WorklistUIActions';

export interface WorklistSidepanelState {
  selectedWorklistId: string | null;
}

export class WorklistSidepanelSelector {
  constructor(readonly state: BenchlingState) {
    this.state = state;
  }

  getSidepanelState(): WorklistSidepanelState {
    return this.state.ui.worklistSidepanelState;
  }
}

export default function reduceWorklistSidepanelState(
  state: WorklistSidepanelState = {selectedWorklistId: null},
  action: BenchlingAction
): WorklistSidepanelState {
  switch (action.type) {
    case WorklistUIActionType.UPDATE_SIDEPANEL_SELECTED_WORKLIST: {
      const {worklistId} = action;
      return {...state, selectedWorklistId: worklistId};
    }
    default:
      return state;
  }
}
